import { render } from "./App.vue?vue&type=template&id=f4e167cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f4e167cc&lang=scss"

import exportComponent from "C:\\Users\\SabariSivaraj\\Pictures\\Screenshots\\HLX Website\\halleyx-website-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__